import { createAction } from '@reduxjs/toolkit';

const domain = 'teamleader/Services/PreferencesService';

export const SET_WEB_APP_PREFERENCE = `${domain}/SET_WEB_APP_PREFERENCE`;
export const SET_WEB_APP_PREFERENCE_SUCCESS = `${domain}/SET_WEB_APP_PREFERENCE_SUCCESS`;
export const SET_WEB_APP_PREFERENCE_FAILURE = `${domain}/SET_WEB_APP_PREFERENCE_FAILURE`;

export const setWebAppPreference = createAction(SET_WEB_APP_PREFERENCE, (key: string, value: string) => ({
  payload: { key, value },
}));
export const setWebAppPreferenceSuccess = createAction(SET_WEB_APP_PREFERENCE_SUCCESS, () => ({ payload: {} }));
export const setWebAppPreferenceFailure = createAction(SET_WEB_APP_PREFERENCE_FAILURE, () => ({ payload: {} }));
